import React from "react";
import FormElement, { FormElementProps } from "../forms/common/FormElement";
import { TextAutosuggest, TextAutosuggestProps } from "../formx/TextAutosuggest";

type Props = FormElementProps & {
  TextAutosuggestProps: TextAutosuggestProps;
};

export function TextAutosuggestFormElement(props: Props) {
  const { TextAutosuggestProps: textAutosuggestProps, ...rest } = props;

  return (
    <FormElement
      required={props.required}
      field={<TextAutosuggest {...textAutosuggestProps} />}
      id={textAutosuggestProps.name}
      {...rest}
    />
  );
}
